import React from "react";
import { designTokens } from "../helpers/constants";
import { FillProps } from "../helpers/icons";

export const DropdownIcon: React.FC<FillProps> = ({
  fill = designTokens["ds-color-gray-0"],
}: FillProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.89418 4.83146C3.17127 4.58901 3.59244 4.61709 3.8349 4.89418L7.99985 9.65412L12.1648 4.89418C12.4073 4.61709 12.8284 4.58901 13.1055 4.83146C13.3826 5.07392 13.4107 5.49509 13.1682 5.77218L8.50156 11.1055C8.37497 11.2502 8.19209 11.3332 7.99985 11.3332C7.80761 11.3332 7.62472 11.2502 7.49813 11.1055L2.83146 5.77218C2.58901 5.49509 2.61709 5.07392 2.89418 4.83146Z"
        fill={fill}
      />
    </svg>
  );
};
